"use strict";
var Coveo = require("coveo-search-ui");
var SearchEndpointHelper = (function () {
    function SearchEndpointHelper() {
    }
    SearchEndpointHelper.initializeEndpoint = function (options) {
        Coveo.SearchEndpoint.endpoints["default"] = new Coveo.SearchEndpoint({
            restUri: options.restEndpointUri,
            queryStringArguments: { 'sitecoreItemUri': options.sitecoreItemUri, 'siteName': options.siteName }
        });
    };
    return SearchEndpointHelper;
}());
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = SearchEndpointHelper;



//////////////////
// WEBPACK FOOTER
// ./Base/SearchEndpointHelper.js
// module id = 12
// module chunks = 0